import { render, staticRenderFns } from "./Data-board.vue?vue&type=template&id=04c4553d&scoped=true"
import script from "./Data-board.vue?vue&type=script&lang=js"
export * from "./Data-board.vue?vue&type=script&lang=js"
import style0 from "./Data-board.vue?vue&type=style&index=0&id=04c4553d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04c4553d",
  null
  
)

export default component.exports